// API Configuration
// Always use relative URLs - proxy handles routing in dev, CloudFront in prod

export const API_CONFIG = {
  endpoint: '',
  getUrl: (path) => {
    // Always return relative path
    // Development: setupProxy.js routes /api/* to API Gateway
    // Production: CloudFront routes /api/* to API Gateway origin
    return path.startsWith('/') ? path : `/${path}`;
  }
};

console.log('🔗 Using relative API URLs (proxied)');
